import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpFSWalletPinTransactionRepository } from 'projects/wallet-pin-creation-webview/src/app/data/repository/fs-wallet-pin-transaction/http-fs-wallet-pin-transaction.repository';
import { MockFSWalletPinTransactionRepository } from 'projects/wallet-pin-creation-webview/src/app/data/repository/fs-wallet-pin-transaction/mock/mock-fs-wallet-pin-transaction.repository';
import { environment } from '../../../../../environments/environment';
import { FSWalletPinTransactionRepository } from '../../../repository/fs-wallet-pin-transaction.repository';
import { WalletPinMockConfigService } from '../../../services/wallet-pin-mock-config/wallet-pin-mock-config.service';

// Factory function to dynamically select the repository implementation
function repositoryFactory() {
    const httpClient = inject(HttpClient);
    const mockConfigService = inject(WalletPinMockConfigService);

    const useMock = mockConfigService.isMockApiMode();
    const isDebugMode = environment.enable_console_debug;

    if (useMock) {
        if (isDebugMode) {
            console.log('🔧 Using MockFSWalletPinTransactionRepository (Mock API)');
        }
        return new MockFSWalletPinTransactionRepository();
    } else {
        if (isDebugMode) {
            console.log('📡 Using HttpFSWalletPinTransactionRepository (Real API)');
        }
        return new HttpFSWalletPinTransactionRepository(httpClient);
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WalletPinHttpProvider = [
    // Dynamic provider selection based on runtime flag or environment configuration
    {
        provide: FSWalletPinTransactionRepository,
        useFactory: repositoryFactory,
    },
];
